import React from "react";

type Variant = "default" | "light" | "on-orange";

interface NicheHireLogoProps {
  size?: number;
  variant?: Variant;
  markOnly?: boolean;
}

const SANS = "'Inter Tight',-apple-system,BlinkMacSystemFont,sans-serif";

const P = {
  o500: "#E8612A",
  o600: "#CF4F1C",
  o400: "#F07840",
  ink: "#120C07",
  white: "#FFFFFF",
};

export function NicheHireLogo({ size = 40, variant = "default", markOnly = false }: NicheHireLogoProps) {
  const scale = size / 40;

  const markBg = variant === "on-orange" ? P.o600 : P.o500;

  const dotFill = variant === "on-orange" ? P.o400 : P.white;

  const wordNiche = variant === "light" ? P.white : P.ink;
  const wordHire = variant === "light" ? P.o400 : P.o500;

  if (markOnly) {
    return (
      <svg
        viewBox="0 0 40 40"
        width={size}
        height={size}
        fill="none"
        aria-label="NicheHire"
        role="img"
        style={{ display: "inline-block", flexShrink: 0 }}
      >
        <rect width="40" height="40" rx="9" fill={markBg} />
        <rect x="9" y="9" width="22" height="22" rx="5" fill={P.white} opacity="0.06" />
        <path
          d="M17 12 L12 12 L12 28 L17 28"
          stroke={P.white} strokeWidth="2.3" fill="none"
          strokeLinecap="round" strokeLinejoin="round"
        />
        <path
          d="M23 12 L28 12 L28 28 L23 28"
          stroke={P.white} strokeWidth="2.3" fill="none"
          strokeLinecap="round" strokeLinejoin="round"
        />
        <circle cx="20" cy="20" r="2.6" fill={dotFill} opacity={0.9} />
      </svg>
    );
  }

  const TW = 185, TH = 40;
  return (
    <svg
      viewBox={`0 0 ${TW} ${TH}`}
      width={Math.round(TW * scale)}
      height={Math.round(TH * scale)}
      fill="none"
      aria-label="NicheHire"
      role="img"
      style={{ display: "inline-block", flexShrink: 0 }}
    >
      <rect width="40" height="40" rx="9" fill={markBg} />
      <rect x="9" y="9" width="22" height="22" rx="5" fill={P.white} opacity="0.06" />
      <path
        d="M17 12 L12 12 L12 28 L17 28"
        stroke={P.white} strokeWidth="2.3" fill="none"
        strokeLinecap="round" strokeLinejoin="round"
      />
      <path
        d="M23 12 L28 12 L28 28 L23 28"
        stroke={P.white} strokeWidth="2.3" fill="none"
        strokeLinecap="round" strokeLinejoin="round"
      />
      <circle cx="20" cy="20" r="2.6" fill={dotFill} opacity={0.9} />
      <text
        x="52" y="22.5"
        fontFamily={SANS}
        fontSize="25" letterSpacing="-0.4"
        dominantBaseline="middle"
        fill={wordNiche}
      >
        <tspan fontWeight="500">Niche</tspan><tspan fontWeight="700" fill={wordHire}>Hire</tspan>
      </text>
    </svg>
  );
}

export default NicheHireLogo;
